module.exports = __webpack_public_path__ + "img/28.4.NH3-N.06fa7dc5.png";